import Swiper from 'swiper';
import { Navigation, Keyboard, A11y, Controller } from 'swiper/modules';

class SliderImg {
  constructor() {
    this.sliders = [];
    [].forEach.call(window.wrapper.querySelectorAll('.block--slider-img'), (block) => {
      this.init(block);
    });
  }

  init(block) {
    const sliders = block.querySelectorAll('.block--slider-img__slider')

    if(sliders.length < 2){
      return;
    }

    [].forEach.call(sliders, (slider, index) => {
      this.sliders[index] = SliderImg.initSlider(slider, index);
    });

    this.sliders[1].controller.control = [this.sliders[0], this.sliders[2]];
  }

  static initSlider(slider, index) {
    const { id } = slider.dataset;

    return new Swiper(slider, {
      modules: [Navigation, Keyboard, A11y, Controller],
      speed: 600,
      allowTouchMove: index === 1,
      grabCursor: index === 1,
      initialSlide: index,
      resistanceRatio: 0.55,
      navigation: {
        nextEl: `[data-prev="${id}"]`,
        prevEl: `[data-next="${id}"]`
      },
      on: {
        init() {
          window.lazyLoad.update();
          this.slideTo(0);
        }
      }
    });
  }
}

export default SliderImg;
